// extracted by mini-css-extract-plugin
export default {"custom-tag":"InlineCode_custom-tag__NW-vi"};